<template>
    <iframe :src="registration_url" style="width:100%;height:100%;"></iframe>
</template>

<script>
import { useAppStore } from '../stores/app'

export default {
    name: 'Register',
    created: function() {
        this.app = useAppStore()
    },
    data: function() {
        return {
            app: null
        }
    },
    computed: {
        registration_url: function() {
            let url = app?.site?.domain_settings?.settings?.domain?.meta?.registration_url[0] ?? "https://account.viphuddles.com/essentials-account"
            url += "?domain="+window.location.host
            console.log("url", url)
            return url
        }
    }
}
</script>